import { useNavigate } from "react-router-dom";
import { siteConfig } from "../config/site";
import { products } from "../data/products";
import { enterProduct } from "../lib/navigation";
import type { Product } from "../types";
import { BrandLogo } from "./BrandLogo";

export function SiteFooter() {
  const navigate = useNavigate();

  function handleProduct(product: Product) {
    enterProduct(product);
  }

  return (
    <footer className="site-footer">
      <div className="site-footer__brand">
        <BrandLogo />
        <p>面向会计师与税务师事务所的 AI 服务平台。</p>
      </div>
      <div className="site-footer__links">
        <div>
          <strong>产品</strong>
          {products.map((product) => (
            <button key={product.id} type="button" onClick={() => handleProduct(product)}>
              {product.name}
            </button>
          ))}
        </div>
        <div>
          <strong>信任与责任</strong>
          <button type="button" onClick={() => navigate("/security")}>
            安全与合规
          </button>
        </div>
      </div>
      <div className="site-footer__legal">
        <div className="site-footer__legal-meta">
          <a
            className="site-footer__icp"
            href={siteConfig.icpFilingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {siteConfig.icpFiling}
          </a>
          <span className="site-footer__legal-sep" aria-hidden="true">
            ·
          </span>
          <span>{siteConfig.companyName}</span>
          <span className="site-footer__legal-sep" aria-hidden="true">
            ·
          </span>
          <span>
            © {siteConfig.copyrightYear} {siteConfig.name}
          </span>
        </div>
      </div>
    </footer>
  );
}
